module.exports = __webpack_public_path__ + "static/media/translate.39e45d5c.svg";